import httpService from '@Utils/httpService';
import store from '@/store';

const baseUrl = 'api/tags/operation';

function facilityHeaders() {
  const facilityId = store.state.assetId;
  return facilityId ? { 'X-Facility-Id': facilityId } : {};
}

export default {
  /**
   * Get operation tags with typeahead search
   * @param {Object} params - Search parameters
   * @param {AbortSignal} [signal] - Optional AbortSignal for cancellation
   */
  get(params, signal = null) {
    return httpService.get({
      url: `${baseUrl}/typeHead`,
      params,
      signal,
    });
  },
  /**
   * Get operation tag by type and ID
   * @param {string} type - Operation type
   * @param {string} id - Tag ID
   * @param {AbortSignal} [signal] - Optional AbortSignal for cancellation
   */
  getById(type, id, signal = null) {
    // assetId is optional and additive server-side: with it, a group-owned scaffold-family tag is
    // resolved to THIS facility's placement (TagFacilityOverride); without it the legacy
    // facility-less shape is returned (AVA-492 Phase 2).
    const assetId = store.state.assetId;
    return httpService.get({
      url: `${baseUrl}/${type}/${id}`,
      params: assetId ? { assetId } : undefined,
      signal,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
  getDeletionImpactScaffolds(ids, assetId) {
    return httpService.post({
      url: 'api/scaffolds/deletionImpact',
      data: { guids: ids, assetId },
    });
  },
  getDeletionImpactAnnotations(ids, assetId) {
    return httpService.post({
      url: 'api/annotations/deletionImpact',
      data: { guids: ids, assetId },
      headers: facilityHeaders(),
    });
  },
};
